module.exports = __webpack_public_path__ + "static/media/3H.7278d51d.png";